<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SITE')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-3">
            <cmp-site-select
              ref="siteCode"
              :initialSelectedKey="this.$store.getters.userInfo.siteId"
              :selected="frame0.selectedCodeValue.COD_SITE"
              :page-id="this.$options.name"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_DIV')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-custom-select
              ref="divisionCode"
              :selected="frame0.selectedCodeValue.COD_DIV_TYPE"
              :initialSelectedIndex="0"
              :option-list="customOptions"
            />
            <!--sui-code-select :selected="selectedCode" codeId="" /-->
            <div class="comp_spacing" />
            <sui-text-field
              v-model="frame0.divisionWord"
              :disabled="false"
              :readonly="false"
              max-length="100"
              @keyup.enter="onClickSearch"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RSP')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-custom-select
              ref="picTypeCode"
              :selected="frame0.selectedCodeValue.COD_PIC_TYPE"
              :initialSelectedIndex="0"
              :option-list="customOptions1"
            />
            <!--sui-code-select :selected="selectedCode" codeId="" /-->
            <div class="comp_spacing" />
            <cmp-user-select
              ref="mainUser"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_PRD')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-custom-select
              ref="dateTypeCode"
              :selected="frame0.selectedCodeValue.COD_DATE_TYPE"
              :initialSelectedIndex="0"
              :option-list="customOptions2"
            />
            <div class="comp_spacing" />
            <sui-range-date-picker
              v-model="frame0.range"
              :value="frame0.range"
              typeable
            />
            <!-- @changed="onRangeChanged" -->
            <!--sui-code-select :selected="selectedCode" codeId="" />
            <div class="comp_spacing"></div>
            <sui-date-picker :disabled="false"></sui-date-picker-->
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CSTR_RSP_CLSF')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-code-select
              ref="cstrRspClsfCode"
              codeId="COD_CSTR_RSP_CLSF"
              :selected="frame0.selectedCodeValue.COD_CSTR_RSP_CLSF"
              :initialSelectedIndex="0"
              defaultOption="all"
            />
          </div>
          <!-- <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_PRGS_STATUS')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-custom-select
              ref="prgsSttCode"
              codeId="COD_PRGS_STT"
              :selected="frame0.selectedCodeValue.custom_prgsStt"
              :initialSelectedIndex="complete"
              :option-list="COD_PRGS_STT"
            />
          </div> -->
        </div>

        <div class="btn_wrap">
          <button
            type="button"
            class="comm_btn_Reset"
            @click="onResetClick"
          >
            {{ $t('MSG_BTN_RESET') }}
          </button>
          <button
            v-permission:read="$options.name"
            type="button"
            class="comm_btn_Scr"
            @click="onClickSearch"
          >
            {{ $t('MSG_BTN_SEARCH') }}
          </button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grid"
        :columns="gridColumns0"
        :dataset="'dsProgressCondition'"
        :rowMovable="false"
        :multiselect="false"
        :pageable="false"
        :autoheight="false"
        :showDisplayCountControl="false"
        :initial-pagesize="10"
      >
        <!-- :initial-pagesize="10" -->
        <div class="btn_wrapR">
          <button
            type="button"
            class="comm_btn_gridTop comm_ico_excel"
            @click="onClickExcelDown"
          >
            {{ $t('MSG_BTN_EXCEL_DOWN') }}
          </button>
        </div>
      </sui-grid>
    </sui-page-contents>
  </sui-page>
</template>
<script>
export default {
  name: 'PGE_BQZ_00004', // eslint-disable-line vue/name-property-casing
  data() {
    return {
      allowedMasks: {
        '#': {
          test: char => char.match(/[0-9]/),
          convert: char => char,
        },
      },
      // Codes
      customOptions: [
        { key: '01', label: '의뢰명' },
        { key: '02', label: '공사명' },

      ],
      customOptions1: [
        { key: '01', label: '공사담당자' },
        { key: '02', label: '발주담당자' },
        { key: '03', label: '연관담당자' },

      ],
      customOptions2: [
        { key: '01', label: '의뢰일' },
        { key: '02', label: '준공일' },
        { key: '03', label: '발주일' },
        { key: '04', label: '검수결재완료일' },
        { key: '05', label: '예상비용산출완료일' },
      ],
      COD_PRGS_STT: [
        { type: 'complete', key: 'complete', label: '시방서 작성완료' },
        { type: 'complete', key: 'ing', label: 'W/O작성중' },
        { type: 'cancel', key: 'cancel', label: '폐찰' },
        { type: 'waiting', key: 'waiting', label: '유찰' },
      ],
      frame0: {
        selectedCodeValue: {
          COD_SITE: { label: '', key: '' }, // 사업장 코드
          COD_CSTR_RSP_CLSF: { label: '', key: '' }, // 공사담당분류
          COD_DIV_TYPE: { label: '', key: '' }, // 구분
          COD_PIC_TYPE: { label: '', key: '' }, // 담당
          COD_PRGS_STT: { label: '', key: '' }, // 진행상태
          COD_DATE_TYPE: { label: '', key: '' }, // 기간
        },
        range: { // 기간
          from: utils.toStringByFormat(utils.addMonth(utils.now(), -3), 'YYYY-MM-DD'),
          to: utils.now('YYYY-MM-DD'),
        },
        siteId: '',
        personInChargeId: '',
        divisionWord: '',
        dateType: '',
        dateToValue: '',
        dateFromValue: '',
      },
      localdata0: [],
      gridColumns0: [
      //   {
      //   text: this.$t('MSG_TXT_PRGS_STATUS'), // '진행상태'
      //   datafield: '',
      //   width: '150',
      //   createwidget: (row, column, value, htmlElement) => {
      //     utils.getGridCellFactory().createCellBadge(row, column, value, htmlElement, {
      //       optionList: this.COD_PRGS_STT,
      //       handler: this.onGridStateClicked,
      //     }, this.dsProgressCondition, this.$refs.grid);
      //   },
      //   initwidget(row, column, value, htmlElement) {
      //     utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      //   },
      // },
        {
          text: this.$t('MSG_TXT_REQ_NO'), // '의뢰번호',
          datafield: 'requestNumber',
          width: '80',
        }, {
          text: this.$t('MSG_TXT_REQ_NM'), // '의뢰명',
          datafield: 'constructionRequestName',
          width: '150',
        }, {
          text: this.$t('MSG_TXT_CSTR_NO'), // '공사번호',
          datafield: 'constructionNumber',
          width: '180',
        }, {
          text: this.$t('MSG_TXT_CSTR_NAME'), // '공사명',
          datafield: 'detailConstructionName',
          width: '150',
        }, {
          text: this.$t('MSG_TXT_CSTR_RSP_CLSF'), // '공사담당분류',
          datafield: 'constructionResponsibilityClassificationCodeName',
          width: '180',
        }, {
          text: this.$t('MSG_TXT_CSTR_RSP_USR'), // '공사담당자',
          datafield: 'constructionResponsibilityUserIdName',
          width: '90',
        }, {
          text: this.$t('MSG_TXT_ODER_RSP_USR'), // '발주담당자',
          datafield: 'orderResponsibilityUserIdName',
          width: '90',
        }, {
          text: this.$t('MSG_TXT_DIV'), // '구분',
          datafield: 'constructionTypeCodeName',
          width: '90',
        }, {
          text: '예상비용산출 의뢰일',
          datafield: 'budgetCalculationRequestDTM',
          width: '90',
          createwidget: (row, column, value, htmlElement) => {
            utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
              handler: this.onGridButtonClickedReq,
              type: 'link',
              checkEditableFunction: this.checkEditable,
            }, this.dsProgressCondition, this.$refs.grid);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        }, {
          text: '예상비용산출 접수일',
          datafield: 'constructionRequestReceiveDT',
          width: '90',
          createwidget: (row, column, value, htmlElement) => {
            utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
              handler: this.onGridButtonClickedReg,
              type: 'link',
              checkEditableFunction: this.checkEditable,
            }, this.dsProgressCondition, this.$refs.grid);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        }, {
          text: '예상비용산출 완료일',
          datafield: 'instructionsReviewDTM',
          width: '90',
          createwidget: (row, column, value, htmlElement) => {
            utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
              handler: this.onGridButtonClickedComp,
              type: 'link',
              checkEditableFunction: this.checkEditable,
            }, this.dsProgressCondition, this.$refs.grid);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        }, {
          text: '공시의뢰일',
          datafield: 'constructionRequestDraftDTM',
          width: '90',
          createwidget: (row, column, value, htmlElement) => {
            utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
              handler: this.onGridButtonClickedCstr,
              type: 'link',
              checkEditableFunction: this.checkEditable,
            }, this.dsProgressCondition, this.$refs.grid);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        }, {
          text: this.$t('MSG_TIT_SPDOC_WKOD_LIST_SRCH'), // '시방서/WO완료일',
          datafield: 'constructionDTM',
          width: '90',
          createwidget: (row, column, value, htmlElement) => {
            utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
              handler: this.onGridButtonClickedWo,
              checkEditableFunction: this.checkEditable,
              type: 'link',
            }, this.dsProgressCondition, this.$refs.grid);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        }, {
          text: '입찰공고일',
          datafield: 'biddingAnnouncementRegistrationDTM',
          width: '90',
          createwidget: (row, column, value, htmlElement) => {
            utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
              handler: this.onGridButtonClickedAnnm,
              checkEditableFunction: this.checkEditable,
              type: 'link',
            }, this.dsProgressCondition, this.$refs.grid);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        }, {
          text: this.$t('MSG_TXT_XP_PROC'), // '비용처리',
          datafield: 'constructionExpenseDivisionCodeName',
          width: '90',
        }, {
          text: '사전평가상태',
          datafield: 'environmentSafetyAdvanceEvaluationProgressStateCodeName',
          width: '90',
        }, {
          text: '견적제출 시작일',
          datafield: 'estimateSubmitStartDTM',
          width: '90',
        }, {
          text: '견적제출 종료일',
          datafield: 'estimateSubmitDeadlineDTM',
          width: '90',
        }, {
          text: '견적개봉일',
          datafield: 'estimateUnsealDTM',
          width: '90',
          createwidget: (row, column, value, htmlElement) => {
            utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
              handler: this.onGridButtonClickedUsel,
              type: 'link',
              checkEditableFunction: this.checkEditable,
            }, this.dsProgressCondition, this.$refs.grid);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        }, {
          text: '입찰결과',
          datafield: 'biddingProgressStateCodeName',
          width: '90',
        }, {
          text: '견적협의',
          datafield: 'estimateDiscussionDTM',
          width: '90',
          createwidget: (row, column, value, htmlElement) => {
            utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
              handler: this.onGridButtonClickedDscs,
              type: 'link',
              checkEditableFunction: this.checkEditable,
            }, this.dsProgressCondition, this.$refs.grid);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        }, {
          text: '발주',
          datafield: 'orderDTM',
          width: '90',
          createwidget: (row, column, value, htmlElement) => {
            utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
              handler: this.onGridButtonClickedOder,
              type: 'link',
              checkEditableFunction: this.checkEditable,
            }, this.dsProgressCondition, this.$refs.grid);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        }, {
          text: '계약',
          datafield: 'contractDocumentDraftDTM',
          width: '90',
          createwidget: (row, column, value, htmlElement) => {
            utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
              handler: this.onGridButtonClickedCtrt,
              type: 'link',
              checkEditableFunction: this.checkEditable,
            }, this.dsProgressCondition, this.$refs.grid);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        }, {
          text: '설계변경횟수',
          datafield: 'designChangeSNCount',
          width: '90',
        }, {
          text: '공사시작일',
          datafield: 'constructionStartDT',
          width: '90',
        }, {
          text: '공사종료일',
          datafield: 'constructionDT',
          width: '90',
        }, {
          text: '검수완료일',
          datafield: 'dTM',
          width: '90',
          createwidget: (row, column, value, htmlElement) => {
            utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
              handler: this.onGridButtonClickedTally,
              type: 'link',
              checkEditableFunction: this.checkEditable,
            }, this.dsProgressCondition, this.$refs.grid);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        }, {
          text: '발주금액',
          datafield: 'ordererAmount',
          width: '120',
          // createwidget: (row, column, value, htmlElement) => {
          //   utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement,
          //     {
          //       // trim: true,
          //       mask: 'currency',
          //       checkEditableFunction: this.checkEditableName,
          //     },
          //     this.dsProgressCondition, this.$refs.grid);
          // },
          // initwidget(row, column, value, htmlElement) {
          //   utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          // },
        }, {
          text: '검수확정금액',
          datafield: 'amount',
          width: '90',
          // createwidget: (row, column, value, htmlElement) => {
          //   utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement,
          //     {
          //       // trim: true,
          //       mask: 'currency',
          //       // checkEditableFunction: this.checkEditableName,
          //     },
          //     this.dsProgressCondition, this.$refs.grid);
          // },
          // initwidget(row, column, value, htmlElement) {
          //   utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          // },
        }, {
          text: this.$t('MSG_TXT_CORP_NAME'), // '업체명',
          datafield: 'costRateCompanyIdName',
          width: '90',
        }, {
          text: '업종',
          datafield: 'companyCategoryIdName',
          width: '90',
        }, {
          text: this.$t('MSG_TXT_EXPE_AMT'), // '예상금액',
          datafield: 'constructionExpectationAmount',
          width: '90',
          // createwidget: (row, column, value, htmlElement) => {
          //   utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement,
          //     {
          //       // trim: true,
          //       mask: 'currency',
          //       checkEditableFunction: this.checkEditableName,
          //     },
          //     this.dsProgressCondition, this.$refs.grid);
          // },
          // initwidget(row, column, value, htmlElement) {
          //   utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          // },
        }, {
          text: this.$t('MSG_TXT_SCHDL_AMT'), // '예정금액',
          datafield: 'constructionScheduleAmount',
          // createwidget: (row, column, value, htmlElement) => {
          //   utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement,
          //     {
          //       // trim: true,
          //       mask: 'currency',
          //       checkEditableFunction: this.checkEditableName,
          //     },
          //     this.dsProgressCondition, this.$refs.grid);
          // },
          // initwidget(row, column, value, htmlElement) {
          //   utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          // },
          width: '90',
        }, {
          text: '낙찰금액',
          datafield: 'estimateAmount',
          width: '90',
          // createwidget: (row, column, value, htmlElement) => {
          //   utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement,
          //     {
          //       // trim: true,
          //       mask: 'currency',
          //       checkEditableFunction: this.checkEditableName,
          //     },
          //     this.dsProgressCondition, this.$refs.grid);
          // },
          // initwidget(row, column, value, htmlElement) {
          //   utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          // },
        }, {
          text: '연관담당자',
          datafield: 'connectionResponsibilityUserIdName',
          width: '90',
        }],
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dsProgressCondition',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'constructionTypeCodeName', map: 'constructionTypeCodeName' },
      { type: 'string', name: 'requestNumber', map: 'requestNumber' },
      { type: 'string', name: 'constructionRequestName', map: 'constructionRequestName' },
      { type: 'string', name: 'constructionNumber', map: 'constructionNumber' },
      { type: 'string', name: 'detailConstructionName', map: 'detailConstructionName' },
      { type: 'string', name: 'constructionResponsibilityUserIdName', map: 'constructionResponsibilityUserIdName' },
      { type: 'string', name: 'orderResponsibilityUserIdName', map: 'orderResponsibilityUserIdName' },
      { type: 'string', name: 'budgetCalculationRequestDTM', map: 'budgetCalculationRequestDTM' },
      { type: 'string', name: 'constructionRequestReceiveDT', map: 'constructionRequestReceiveDT' },
      { type: 'string', name: 'instructionsReviewDTM', map: 'instructionsReviewDTM' },
      { type: 'string', name: 'constructionRequestDraftDTM', map: 'constructionRequestDraftDTM' },
      { type: 'string', name: 'constructionDTM', map: 'constructionDTM' },
      { type: 'string', name: 'biddingAnnouncementRegistrationDTM', map: 'biddingAnnouncementRegistrationDTM' },
      { type: 'string', name: 'constructionExpenseDivisionCodeName', map: 'constructionExpenseDivisionCodeName' },
      { type: 'string', name: 'estimateSubmitStartDTM', map: 'estimateSubmitStartDTM' },
      { type: 'string', name: 'estimateSubmitDeadlineDTM', map: 'estimateSubmitDeadlineDTM' },
      { type: 'string', name: 'estimateUnsealDTM', map: 'estimateUnsealDTM' },
      { type: 'string', name: 'biddingProgressStateCodeName', map: 'biddingProgressStateCodeName' },
      { type: 'string', name: 'estimateDiscussionDTM', map: 'estimateDiscussionDTM' },
      { type: 'string', name: 'orderDTM', map: 'orderDTM' },
      { type: 'string', name: 'contractDocumentDraftDTM', map: 'contractDocumentDraftDTM' },
      { type: 'string', name: 'designChangeSNCount', map: 'designChangeSNCount' },
      { type: 'string', name: 'constructionStartDT', map: 'constructionStartDT' },
      { type: 'string', name: 'constructionDT', map: 'constructionDT' },
      { type: 'string', name: 'dTM', map: 'dTM' },
      { type: 'string', name: 'ordererAmount', map: 'ordererAmount' },
      { type: 'string', name: 'amount', map: 'amount' },
      { type: 'string', name: 'costRateCompanyIdName', map: 'costRateCompanyIdName' },
      { type: 'string', name: 'companyCategoryIdName', map: 'companyCategoryIdName' },
      { type: 'string', name: 'constructionExpectationAmount', map: 'constructionExpectationAmount' },
      { type: 'string', name: 'constructionScheduleAmount', map: 'constructionScheduleAmount' },
      { type: 'string', name: 'estimateAmount', map: 'estimateAmount' },
      { type: 'string', name: 'connectionResponsibilityUserIdName', map: 'connectionResponsibilityUserIdName' },
      {
        type: 'string',
        name: 'environmentSafetyAdvanceEvaluationProgressStateCodeName',
        map: 'environmentSafetyAdvanceEvaluationProgressStateCodeName',
      },
      {
        type: 'string',
        name: 'constructionResponsibilityClassificationCodeName',
        map: 'constructionResponsibilityClassificationCodeName',
      },
    ],
  }],
  mounted() {
    this.onClickSearch();
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /**
     *  검색
     */
    onClickSearch() {
      const userInfo = this.$refs.mainUser.getValue();
      const toDate = utils.dateformatToServer(this.frame0.range.to);
      const fromDate = utils.dateformatToServer(this.frame0.range.from);
      const queryParams = {
        siteId: this.frame0.selectedCodeValue.COD_SITE.key,
        personInChargeType: this.frame0.selectedCodeValue.COD_PIC_TYPE.key,
        personInChargeId: !utils.isEmpty(userInfo) ? userInfo.userId : '',
        divisionType: this.frame0.selectedCodeValue.COD_DIV_TYPE.key,
        divisionWord: this.frame0.divisionWord,
        dateType: this.frame0.selectedCodeValue.COD_DATE_TYPE.key,
        dateToValue: toDate,
        dateFromValue: fromDate,
        constructionResponsibilityClassificationCode: this.frame0.selectedCodeValue.COD_CSTR_RSP_CLSF.key,
      };

      http.request(this.$options.name, 'DTS_BQZ_00015', {
        query: queryParams,
      }).then(res => {
        utils.forEach(res.data, (obj, key) => {
          const dtmList = [
            'budgetCalculationRequestDTM',
            'instructionsReviewDTM',
            'constructionRequestDraftDTM',
            'constructionDTM',
            'biddingAnnouncementRegistrationDTM',
            'estimateUnsealDTM',
            'estimateDiscussionDTM',
            'orderDTM',
            'contractDocumentDraftDTM',
            'dTM',
            'estimateSubmitStartDTM',
            'estimateSubmitDeadlineDTM',
            'constructionStartDT',
            'constructionDT',
          ];
          const amountList = [
            'ordererAmount',
            'constructionScheduleAmount',
            'amount',
            'constructionExpectationAmount',
            'estimateAmount',
          ];

          utils.forEach(dtmList, dtm => {
            if (!utils.isEqual(res.data[key][dtm], '-')) {
              res.data[key][dtm] = utils.dateformatToClient(res.data[key][dtm], 'S');
            }
          });

          utils.forEach(amountList, amount => {
            if (!utils.isEmpty(res.data[key][amount])) {
              const currency = this.getCurrency(res.data[key][amount]);
              res.data[key][amount] = currency.text;
            }a
          });
        });

        this.dsProgressCondition.setRawData(res.data); // 데이터 셋에 데이터를 넣는 함수
      });

      const test = [];
      for (let i = 0; i < 100; i++) {
        test.push(
          {
            amount: null,
            biddingAnnouncementRegistrationDTM: i % 2 ? '-' : '20190827055004',
            biddingProgressStateCodeName: '낙찰',
            budgetCalculationRequestDTM: '20190628165259',
            companyCategoryIdName: '-',
            connectionResponsibilityUserIdName: '-',
            constructionDT: '20191231',
            constructionDTM: i % 3 ? '20190827055004' : '-',
            constructionExpectationAmount: '266000000.000',
            constructionExpenseDivisionCodeName: '투자',
            constructionNumber: 'C190628036_01',
            constructionRequestDraftDTM: '20190822160445',
            constructionRequestName: 'R5 5층 UPS  배터리 교체공사',
            constructionRequestReceiveDT: '-',
            constructionResponsibilityClassificationCode: null,
            constructionResponsibilityClassificationCodeName: 'G-EHS 센터 - 건설기술',
            constructionResponsibilityUserIdName: '양동석',
            constructionScheduleAmount: '266000000.000',
            constructionStartDT: '20190909',
            constructionTypeCodeName: '시방서',
            contractDocumentDraftDTM: i % 3 ? '20190909000000' : '-',
            costRateCompanyIdName: '삼성엔지니어링(주)',
            dTM: '-',
            dateFromValue: null,
            dateToValue: null,
            dateType: null,
            deleteYn: null,
            designChangeSNCount: null,
            detailConstructionName: 'UPS배터리 교체공사',
            divisionType: null,
            divisionWord: null,
            environmentSafetyAdvanceEvaluationProgressStateCodeName: '비대상',
            estimateAmount: '239000000.000',
            estimateDiscussionDTM: '20190905181132',
            estimateSubmitDeadlineDTM: '20190830140000',
            estimateSubmitStartDTM: '20190830090000',
            estimateUnsealDTM: '20190830140334',
            instructionsReviewDTM: '20190716      ',
            orderDTM: i % 2 ? '20190909000000' : '-',
            orderResponsibilityUserIdName: '양동석',
            ordererAmount: '239000000.000',
            originalFinalModificationDTM: null,
            personInChargeId: null,
            personInChargeType: null,
            requestNumber: 'C190628036',
            siteId: null,
          },
        );
      }

      this.dsProgressCondition.setRawData(test);
    },
    /**
     *  엑셀 다운로드
     */
    onClickExcelDown() {
      utils.downloadGridToExcel(
        this.$options.name,
        this.gridColumns0,
        this.dsProgressCondition,
        'progressSituation.xlsx',
      );
    },
    /**
     *  리셋
     */
    onResetClick() {
      // 기간 초기화 :현재날짜에서 - 3개월
      this.frame0.range = {
        from: utils.toStringByFormat(utils.addMonth(utils.now(), -3), 'YYYY-MM-DD'),
        to: utils.now('YYYY-MM-DD'),
      };
      // 사업장 코드 세션 값으로 초기화
      this.frame0.selectedCodeValue.COD_SITE.key = this.$store.getters.userInfo.siteId;

      this.$refs.divisionCode.reset(); // 구분
      this.$refs.picTypeCode.reset(); // 담당
      this.$refs.dateTypeCode.reset(); // 기간
      this.$refs.cstrRspClsfCode.reset(); // 공사담당분류 초기화
      this.$refs.mainUser.reset();
      this.frame0.divisionWord = ''; // 구분 텍스트필드
    },
    // 예상비용산출 의뢰일
    onGridButtonClickedReq(event, dataRow) {
      const pageId = 'PGE_BQZ_00002';
      this.openNewWindow(pageId, 'constructionNumber', dataRow.constructionNumber);
    },
    // 예상비용산출 접수일
    onGridButtonClickedReg(event, dataRow) {
      const pageId = 'PGE_BQZ_00002';
      this.openNewWindow(pageId, 'constructionNumber', dataRow.constructionNumber);
    },
    // 예상비용산출 완료일
    onGridButtonClickedComp(event, dataRow) {
      const pageId = 'PGE_BQR_00006';
      this.openNewWindow(pageId, 'constructionNumber', dataRow.constructionNumber);
    },
    // 공사의뢰일
    onGridButtonClickedCstr(event, dataRow) {
      const pageId = 'PGE_BQR_00009';
      this.openNewWindow(pageId, 'constructionNumber', dataRow.constructionNumber);
    },
    // 시방서/WO완료일
    onGridButtonClickedWo(event, dataRow) {
      const pageId = 'PGE_BQR_00024';
      this.openNewWindow(pageId, 'constructionNumber', dataRow.constructionNumber);
    },
    // 입찰공고일
    onGridButtonClickedAnnm(event, dataRow) {
      const pageId = 'PGE_BQB_00005';
      this.openNewWindow(pageId, 'constructionNumber', dataRow.constructionNumber);
    },
    // 견적개봉일
    onGridButtonClickedUsel(event, dataRow) {
      const pageId = 'PGE_BQB_00007';
      this.openNewWindow(pageId, 'constructionNumber', dataRow.constructionNumber);
    },
    // 견적협의
    onGridButtonClickedDscs(event, dataRow) {
      const pageId = 'PGE_BQB_00007';
      this.openNewWindow(pageId, 'constructionNumber', dataRow.constructionNumber);
    },
    // 발주
    onGridButtonClickedOder(event, dataRow) {
      console.log(dataRow);
      const pageId = 'PGE_BQO_00004';
      this.openNewWindow(pageId, 'constructionNumber', dataRow.constructionNumber);
    },
    // 계약
    onGridButtonClickedCtrt(event, dataRow) {
      const pageId = 'PGE_BQO_00012';
      this.openNewWindow(pageId, 'constructionNumber', dataRow.constructionNumber);
    },
    // 검수완료일
    onGridButtonClickedTally(event, dataRow) {
      const pageId = 'PGE_BQP_00006';
      this.openNewWindow(pageId, 'constructionNumber', dataRow.constructionNumber);
    },
    /**
     *  새창으로 열기 함수
     */
    openNewWindow(pageId, key, value) {
      let url = '';
      const queryString = `?${key}=${value}`;
      if (pageId) {
        const hash = utils.replace(window.location.hash, this.$options.name, pageId);
        url = `http://${window.location.host}${window.location.pathname}${window.location.search}${hash}${queryString}`;
      } else {
        url = `http://${window.location.host}/${window.location.hash}`;
      }
      const win = window.open();
      win.location = url;
    },
    /**
     *  Currency mask 관련 함수.
     */
    onlyNums(text) {
      let ret = '';
      for (let i = 0; i < text.length; i += 1) {
        if (this.allowedMasks['#'].test(text[i])) { ret += text[i]; }
      }
      return ret;
    },
    numberWithCommas(number, comma = ',') {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, comma);
    },
    getCurrency(inputValue = '') {
      let digitGroupType = null;
      if (this.$store.getters.userInfo && this.$store.getters.userInfo.digitGroupType) {
        digitGroupType = this.$store.getters.userInfo.digitGroupType;
      }
      let decimal = '.';
      let comma = ',';
      if (digitGroupType) {
        comma = digitGroupType.substr(1, 1);
        decimal = digitGroupType.substr(5, 1);
      }
      const hasDecimal = (inputValue.indexOf(decimal) >= 0);

      let sign = '';
      if (inputValue[0] === '-') { // 부호 체크
        sign = inputValue[0];
      }

      const splittedValue = inputValue.split(decimal);
      const decimalValue = splittedValue[0];
      let decimalNumber = this.onlyNums(decimalValue);
      let pointNumber = '';
      if (splittedValue.length > 1) {
        pointNumber = splittedValue[1].substring(0, this.decimalLength);
      }
      pointNumber = this.onlyNums(pointNumber);
      decimalNumber = sign + decimalNumber;
      decimalNumber = (decimalNumber.length <= 2 && isNaN(parseInt(decimalNumber))) ? 0 : parseInt(decimalNumber);

      let decimalText = '';
      if (decimalNumber !== 0) {
        decimalText = this.numberWithCommas(Math.abs(decimalNumber), comma);
      }

      const value = hasDecimal ? `${decimalNumber}.${pointNumber}` : `${decimalNumber}`;
      const text = (hasDecimal && decimalNumber !== 0)
        ? `${sign}${decimalText}${decimal}${pointNumber}`
        : `${sign}${decimalText}`;
      return {
        value,
        text,
      };
    },
    /**
     *  날짜 값이 없는 경우 버튼 이벤트 사용x
     */
    checkEditable(rowData, columnName, dataset, grid) {
      if (utils.isEqual(rowData[columnName], '-')) {
        return false;
      }
      return true;
    },
  },
};
</script>
<style scoped>
</style>
